
import router from "@/router";
import { useStore } from "vuex";
import { useMutations } from "@/store/helper";
import Spinner from "@/components/layout/Spinner.vue";
import Checkbox from "@/components/layout/Checkbox.vue";
import Direccion from "@/components/layout/Direccion.vue";
import DivipolaDian from "@/components/layout/DivipolaDian.vue";
import { ref, reactive, defineComponent, onMounted } from "vue";
import Tooltip from "@/components/layout/TooltipTransmission.vue";
import { DatosPago } from "@/models/payment";
import MessageToClient from "@/components/Payment/MessageToClient.vue";
import ValidadorFranjaHoraria from "@/components/layout/ValidadorFranjaHoraria.vue";
import {
  colombianCurrencyValidator,
  normalizeNumberValidator,
  thousandsSeparatorFormat,
} from "@/store/Payment/plans";
import ProveedorPago from "../models/payment/ProveedorPago";
import RedirectToKhuski from "@/components/Payment/RedirectToKhuski.vue";
import { validationRules } from "@/validation/PaylinePaymentForm";
import { soloPermitirNumeros } from "@/helpers/helpers";
import ValidacionRechazada from "primevue/dialog";
import ValidacionExpirada from "primevue/dialog";
import ErrorValidacion from "primevue/dialog";
import {
  ESTADOS_CORRECCION,
  ESTADOS_ERROR_VALIDACION,
  ESTADOS_VALIDACION,
  EXPIRADA,
  RECHAZADA,
} from "@/models/payment/EstadosValidadorAeL";
import { useRoute } from "vue-router";

export default defineComponent({
  name: "PaylinePaymentForm",
  props: {},
  components: {
    Spinner,
    MessageToClient,
    DivipolaDian,
    Direccion,
    Tooltip,
    Checkbox,
    ValidadorFranjaHoraria,
    RedirectToKhuski,
    ValidacionRechazada,
    ValidacionExpirada,
    ErrorValidacion,
  },
  setup(props) {
    const store = useStore();

    const route = useRoute();
    const bancos = ref([{ codigo: "", nombre: "" }]);
    const formRef = ref<HTMLFormElement>();
    const datosPago = reactive({ ...DatosPago });
    const { setStateMenu } = useMutations(["setStateMenu"]);

    const franjaPagoNoDisponible = ref("");
    const mensajePagoNoDisponible = ref("");
    const pagoRestringido = ref(true);

    const urlChatSoporte =
      "https://empresas.aportesenlinea.com/Home/Contacto.aspx";

    const valuePlan = Number(localStorage.getItem("valuePlan"));
    const documentsCount = Number(localStorage.getItem("documentsCount"));

    setStateMenu(false);

    const processPayment = ref(true);
    const errorPayment = ref(false);
    const validacionRechazada = ref(false);
    const errorValidacion = ref(false);
    const validacionExpirada = ref(false);

    const rules = reactive({ ...validationRules });

    function getBanks() {
      let parametros = {
        token: localStorage.getItem("Tokensin"),
        tipoIdentificacion: localStorage.getItem("TipoIdentificacion"),
        identificacion: localStorage.getItem("Identificacion"),
      };
      store
        .dispatch("GetPasarelaBanks", parametros)
        .then((resp) => {
          bancos.value = resp.data.bancos;
          processPayment.value = false;
        })
        .catch((error) => {
          console.log(error);
        });
    }

    const metadata = () => {
      return {
        banco: datosPago.banco,
      };
    };

    const datosGeneralesFactura = () => {
      return {
        ProveedorPagoId: ProveedorPago.Pasarela,
        descripcion: `Compra del plan de ${documentsCount} documentos por valor de ${thousandsSeparatorFormat(
          valuePlan
        )}`,
        codigoBanco: bancos.value.find((x) => x.nombre === datosPago.banco)
          ?.codigo,
      };
    };

    const amount = () => {
      return {
        subtotalIva: 0,
        subtotalIva0: valuePlan,
        iva: 0,
      };
    };

    const informacionAportante = () => {
      return {
        razonSocial: localStorage.getItem("RazonSocialPila"),
        tipoIdentificacion: localStorage.getItem("TipoIdentificacion"),
        numeroIdentificacion: localStorage.getItem("Identificacion"),
        dv: localStorage.getItem("DV"),
      };
    };

    const informacionTransaccion = (validacionId: string | null = null) => {
      const informacionTransaccion = {
        tokenHeader: localStorage.getItem("Tokensin"),
        token: "",
        amount: JSON.stringify(amount()),
        metadata: JSON.stringify(metadata()),
        datosGenerales: JSON.stringify(datosGeneralesFactura()),
        informacionAportante: JSON.stringify(informacionAportante()),
        tipoIdentificacion: localStorage.getItem("TipoIdentificacion"),
        numeroIdentificacion: localStorage.getItem("Identificacion"),
        CantidadDocumentos: documentsCount,
        ValidacionId: validacionId ?? "",
      };

      return informacionTransaccion;
    };

    const iniciarTransaccion = (validacionId: string | null = null) => {
      store
        .dispatch("GetUrlPayment", informacionTransaccion(validacionId))
        .then((response: any) => {
          let data = response.data;
          if (data != null) {
            window.open(data, "_self");
          } else {
            processPayment.value = false;
            errorPayment.value = true;
          }
        })
        .catch((err) => {
          validarErrorPago(err);
        });
    };

    const cerrarValidacionRechazada = () => {
      validacionRechazada.value = false;
    };

    const cerrarErrorValidacion = () => {
      errorValidacion.value = false;
    };

    const cerrarValidacionExpirada = () => {
      validacionExpirada.value = false;
    };

    const errorEnValidacion = (estado?: string) =>
      !!estado && ESTADOS_ERROR_VALIDACION.some((e) => estado.includes(e));

    const estadoValidacion = (estado?: string) =>
      !!estado && ESTADOS_VALIDACION.some((e) => estado.includes(e));

    const requiereCorreccion = (estado?: string) =>
      !!estado && ESTADOS_CORRECCION.some((e) => estado.includes(e));

    const validarErrorPago = (err: any) => {
      const respuesta = err.response?.data;

      const estado =
        typeof respuesta === "string" ? respuesta : respuesta?.estado ?? "";

      if (requiereCorreccion(estado) && respuesta?.urlPortal) {
        window.location.href = respuesta?.urlPortal;
        return;
      }

      processPayment.value = false;
      switch (estado) {
        case RECHAZADA:
          validacionRechazada.value = true;
          return;

        case EXPIRADA:
          validacionExpirada.value = true;
          return;
      }

      if (errorEnValidacion(estado) || estadoValidacion(estado)) {
        errorValidacion.value = true;
        return;
      }

      errorPayment.value = true;
    };

    function GetKeyVaultSecrets() {
      let parametrosConsulta = {
        token: localStorage.getItem("Tokensin"),
        secret1: "FranjaPagoNoDisponible",
        secret2: "MensajePagoNoDisponible",
      };
      store
        .dispatch("GetKeyVaultSecrets", parametrosConsulta)
        .then((response) => {
          if (response.request.status == 200) {
            franjaPagoNoDisponible.value = JSON.parse(response.data[0].value);
            mensajePagoNoDisponible.value = response.data[1].value;
          }
        })
        .catch((error) => {
          console.log(error.request.response);
        });
    }

    function validarDatosParaPago() {
      if (!pagoRestringido.value) {
        formRef.value?.validate((valid: boolean) => {
          if (valid) {
            processPayment.value = true;
            errorPayment.value = false;
            iniciarTransaccion();
          }
        });
      }
    }

    function obtenerTransaccionMasReciente() {
      const parametrosConsulta = {
        token: localStorage.getItem("Tokensin"),
        proveedorPago: ProveedorPago.Pasarela,
      };

      store
        .dispatch("ObtenerTransaccionMasReciente", parametrosConsulta)
        .then((response) => {
          if (response.request.status === 200 && response.data) {
            Object.assign(datosPago, response.data);
          }
        })
        .catch((error) => {
          console.log(error.request.response);
        });
    }

    function comebackToPlans() {
      router.push({ name: "Plans" });
    }

    const redireccionDesdeMicrositioDeValidacion = (): boolean => {
      const validacionId = route.query.idValidacion?.toString();

      if (!validacionId) return false;

      iniciarTransaccion(validacionId);
      return true;
    };

    onMounted(() => {
      if (redireccionDesdeMicrositioDeValidacion()) {
        return;
      }

      getBanks();
      GetKeyVaultSecrets();
      obtenerTransaccionMasReciente();
    });

    return {
      bancos,
      validarDatosParaPago,
      comebackToPlans,
      datosPago,
      processPayment,
      errorPayment,
      validacionRechazada,
      errorValidacion,
      validacionExpirada,
      cerrarValidacionRechazada,
      cerrarErrorValidacion,
      cerrarValidacionExpirada,
      formRef,
      colombianCurrencyValidator,
      normalizeNumberValidator,
      thousandsSeparatorFormat,
      franjaPagoNoDisponible,
      pagoRestringido,
      mensajePagoNoDisponible,
      store,
      informacionTransaccion,
      valuePlan,
      documentsCount,
      soloPermitirNumeros,
      urlChatSoporte,
      rules,
    };
  },
});
